// extracted by mini-css-extract-plugin
module.exports = {"animateSpin":"spinnerStyle_animateSpin__30OyK","spin":"spinnerStyle_spin__DU-uw"};